import ContentCopy from "@mui/icons-material/ContentCopy";
import { IconButton } from "@mui/material";

export const CopyClipboard: React.FC<{ value: string }> = ({ value }) => {
  return (
    <IconButton
      color="primary"
      onClick={() => {
        navigator.clipboard.writeText(value);
      }}
    >
      <ContentCopy />
    </IconButton>
  );
};
